import { render } from "./Terms.vue?vue&type=template&id=68411002"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/UserGuide/Terms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68411002"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68411002', __exports__)) {
    api.reload('68411002', __exports__)
  }
  
  module.hot.accept("./Terms.vue?vue&type=template&id=68411002", () => {
    api.rerender('68411002', render)
  })

}


export default __exports__